import { gql } from "@apollo/client";

export const GetVmsBoardDetails = gql`
  query GetVmsBoardDetails($token: String!, $customerID: ID!) {
    GetVmsBoardDetails(token: $token, customerID: $customerID) {
      id
      isDeviceOn
      lastConnected
      ticketStatus
      address
      prodLatitude
      prodLongitude
      item {
        icon
        desc
      }
    }
  }
`;
